import keyWrapper from '@bufferapp/keywrapper';

export const actionTypes = keyWrapper('PUSHER', {
  EVENT_VIDEO_TRANSCODED: 0,
});

export const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const actions = {};
